import styled from "styled-components";
import { FlexVerticalContainer } from "@/react/features/styled/WidthContainers";

// Keep the minimum width to "fit-content" and extend the default and maximum to 50% of the main area
export const DidInputContainer = styled(FlexVerticalContainer)`
  width: 50%;
  max-width: 50%;
  gap: 10px;
`;

export const ErrorMessage = styled.div`
  color: red;
  align-items: start;
  justify-content: center;
`;
